import collection from './invitation/collection';
import item from './invitation/item';
import bulk from './invitation/bulk';

const invitation = {
  namespaced: true,
  modules: {
    collection,
    item,
    bulk,
  },
};

export default invitation;
